// Contact / consultation form submissions — no server of our own. Each lead
// is saved to Supabase's `leads` table (the admin panel's Leads tab); the
// public key can only insert there (see supabase/schema.sql). The email alert
// is sent by the database itself (supabase/lead-alerts.sql), so the email
// service's key never reaches the browser. Plain fetch keeps the Supabase
// client library out of the public bundle.

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

export const CONTACT_PHONE = '+91-9555 690 946';

const clip = (value, max) => {
    const text = String(value || '').trim();
    return text ? text.slice(0, max) : null;
};

// Throws if the lead wasn't saved, so callers can show an error (and the
// phone number) instead of silently losing it.
export const submitLead = async ({ name, phone, email, city, message }, source) => {
    if (!SUPABASE_URL || !SUPABASE_KEY) {
        throw new Error('Lead capture is not configured: set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_KEY.');
    }
    const lead = {
        name: clip(name, 120),
        phone: clip(phone, 30),
        email: clip(email, 200),
        city: clip(city, 120),
        message: clip(message, 5000),
        source: clip(source, 300),
        page: clip(window.location.href, 500),
    };
    const headers = { apikey: SUPABASE_KEY, 'Content-Type': 'application/json', Prefer: 'return=minimal' };
    // Legacy anon keys are JWTs and also go in Authorization; new sb_publishable_ keys must not.
    if (!SUPABASE_KEY.startsWith('sb_')) headers.Authorization = `Bearer ${SUPABASE_KEY}`;
    const res = await fetch(`${SUPABASE_URL}/rest/v1/leads`, { method: 'POST', headers, body: JSON.stringify(lead) });
    if (!res.ok) {
        const detail = await res.json().then((j) => j.message).catch(() => '');
        throw new Error(`Saving lead failed (${res.status})${detail ? `: ${detail}` : ''}`);
    }
};
